export default __webpack_public_path__ + "static/hero-about-1ed04d96095270e0beb63b7591902fb9.webp";